import * as React from 'react';
import type { MeetingAnalytics } from '../types';
import { AnalyticsHeader } from './AnalyticsHeader';
import { StatTiles } from './StatTiles';
import { TimingCard } from './TimingCard';
import { OutcomeNotesCard } from './OutcomeNotesCard';
import { AttendanceTable } from './AttendanceTable';
import { RecordingSection } from './RecordingSection';

/** The full analytics view, given already-loaded data. Pure presentation —
 *  loading / error / empty are the container's job. */
export function AnalyticsView({ data }: { data: MeetingAnalytics }) {
  return (
    <div className="space-y-6">
      <AnalyticsHeader data={data} />
      <StatTiles data={data} />
      <TimingCard data={data} />
      <OutcomeNotesCard data={data} />
      <AttendanceTable data={data} />
      <RecordingSection
        meetingId={data.meetingId}
        status={data.recordingStatus}
        durationSeconds={data.recordingDurationSeconds}
        mode={data.recordingMode}
        leadName={data.leadName}
      />
    </div>
  );
}
